import {ChangeDetectionStrategy, Component} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-asset-grid-cell",
    templateUrl: "./asset-grid-cell.component.html",
    styleUrls: ["./asset-grid-cell.component.scss"],
})
export class AssetGridCellComponent {}
